import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Button } from '../../../../../common/html/button'
import { Element } from '../../../../../common/html/element'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import { changePeerOrganizationIds } from '../../../store/slice'
import { changeIsShowPopupCancel } from '../store/slice'
import {
  changeSelectedCompanyList,
  selectSelectedCompanyList,
} from './store/slice'
import { SelectedItem } from './tabs/common/SelectedItem'

export const SelectedCompany = ({ handleClose }) => {
  const dispatch = useDispatch()
  const [disableAdd, setDisableAdd] = useState(true)

  const selectedCompanyList = useSelector(selectSelectedCompanyList)

  useEffect(() => {
    if (!selectedCompanyList.length) {
      setDisableAdd(true)
    } else {
      setDisableAdd(false)
    }
  }, [selectedCompanyList])

  const handleCancel = () => {
    if (selectedCompanyList.length) {
      dispatch(changeIsShowPopupCancel(true))
    } else {
      handleClose()
      dispatch(changePeerOrganizationIds([]))
    }
  }

  const handleAdd = () => {
    const selectedCompanyListIds = selectedCompanyList.map((item) => item.id)
    dispatch(changePeerOrganizationIds(selectedCompanyListIds))
    handleClose()
  }

  const onRemoveItem = (item) => {
    const newSelectedCompanyList = selectedCompanyList.filter(
      (i) => i.id !== item.id,
    )
    dispatch(changeSelectedCompanyList(newSelectedCompanyList))
  }

  return (
    <Element
      className="flexColumn"
      style={{
        width: 'calc(30% - 12px)',
        borderLeftWidth: 1,
        borderLeftColor: '#D5D5D5',
        borderLeftStyle: 'solid',
      }}
    >
      <Element
        className="flexColumn flex1 w100"
        style={{
          marginLeft: 12,
          backgroundColor: '#FFFFFF',
          borderStyle: 'solid',
          borderWidth: 1,
          borderColor: '#D5D5D5',
        }}
      >
        <Element
          style={{
            padding: '8px 12px',
            borderBottomStyle: 'solid',
            borderBottomColor: '#D5D5D5',
            borderBottomWidth: 1,
          }}
        >
          <Translate
            className="fw600"
            id={'SelectedCompany'}
            value={'companyAnalysis.peerAnalysis.SELECTED_COMPANY'}
            numberSelect={selectedCompanyList?.length || 0}
          />
        </Element>
        <ScrollComponent appendStyle={{ flexGrow: 1 }}>
          {selectedCompanyList?.map((item, index) => {
            return (
              <SelectedItem
                key={index}
                item={item}
                index={index}
                onRemoveItem={onRemoveItem}
              />
            )
          })}
        </ScrollComponent>
      </Element>
      <Element className="dFlex justifyContentEnd" style={{ marginTop: 12 }}>
        <Button
          style={{
            padding: '6px 10px',
            minWidth: 100,
            marginRight: 8,
            borderRadius: 4,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#D5D5D5',
            backgroundColor: '#FFFFFF',
            cursor: 'pointer',
          }}
          label="companyAnalysis.peerAnalysis.CANCEL"
          isI18n
          action={handleCancel}
        />
        <Button
          style={{
            padding: '6px 10px',
            minWidth: 100,
            border: 'none',
            borderRadius: 4,
            color: '#FFFFFF',
            backgroundColor: '#2C73E8',
            cursor: disableAdd ? 'not-allowed' : 'pointer',
          }}
          label="companyAnalysis.peerAnalysis.ADD_TO_PEER_LIST"
          isI18n
          action={!disableAdd ? handleAdd : () => {}}
        />
      </Element>
    </Element>
  )
}
